import { render, staticRenderFns } from "./SimpleMarkdownRenderer.vue?vue&type=template&id=65b399b2&scoped=true"
import script from "./SimpleMarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./SimpleMarkdownRenderer.vue?vue&type=script&lang=js"
import style0 from "./SimpleMarkdownRenderer.vue?vue&type=style&index=0&id=65b399b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b399b2",
  null
  
)

export default component.exports